import { styled, alpha } from '@mui/material/styles';

import { NavigationItem } from 'layout/MainLayout/components/Sidebar/components/components/NavigationItem/NavigationItem';
import { OPENED_CONTENT_WIDTH } from 'layout/MainLayout/components/Sidebar/constants';

import type { NavigationItem as NavigationItemType } from 'layout/MainLayout/components/Sidebar/types';

type NavigationItemWrapperState = Pick<NavigationItemType, 'disabled'>;

export const NavigationItemWrapper = styled(
  NavigationItem,
)<NavigationItemWrapperState>(({ theme, disabled }) => ({
  display: 'flex',
  height: 36,
  width: OPENED_CONTENT_WIDTH,
  marginBottom: theme.spacing(2),
  padding: theme.spacing(0.5, 1),
  borderRadius: '24px',
  overflow: 'hidden',
  textDecoration: 'none',
  pointerEvents: disabled ? 'none' : 'auto',
  '&:hover, &:focus, &:focus-visible, &.Mui-focusVisible': {
    // TODO: change to variable from theme
    backgroundColor: theme.palette.grey[100],
  },
  '&.active': {
    backgroundColor: alpha(
      theme.palette.background.secondary,
      theme.palette.action.selectedOpacity,
    ),
  },
}));
